module.exports = __webpack_public_path__ + "static/media/Ulladulla_Educational_4_-_17_July_2011.24d89201.jpg";